export default "__VITE_ASSET__DRSFdkDp__"